import { ComponentRef, ViewContainerRef } from '@angular/core';
import { IgniteTvAccountSelectionComponent } from './ignite-tv-account-selection.component';

class IgniteTvSelectionFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  igniteTvSelectionFormSessionComponentRef: ComponentRef<IgniteTvAccountSelectionComponent>;

  constructor(formId: string, payload: object) {

      this.formId = formId;
      this.payload = payload;
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {


  }
promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    console.log('IgniteTvSelectionFormTs session Input: ' + this.formId);
    this.viewContainerRef.clear();

    this.igniteTvSelectionFormSessionComponentRef = this.viewContainerRef.createComponent(IgniteTvAccountSelectionComponent);

    this.igniteTvSelectionFormSessionComponentRef.instance.onRogersSignInSubmit = this.onRogersSignInSubmit.bind(this);
    this.igniteTvSelectionFormSessionComponentRef.instance.onShawSignInSubmit = this.onShawSignInSubmit.bind(this);

    console.log('IgniteTvSelectionFormTs constructor payload:', this.payload);

    const journeyPayload = this.payload as JourneyPayload;
    console.log('IgniteTvSelectionFormTs:payload actions using interface', journeyPayload.actions);


    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          this.submitBlock = null;
        } catch (e) {

          console.error(e);
        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;

    if (errorPayload.code === 'FB01'){
       this.processRecaptchaFailure();
    }
}
   /** Non UIFormSession interface Functions */
   private onRogersSignInSubmit(payload: object) {
    this.submitBlock(payload);
  }

  private onShawSignInSubmit(payload: object) {
    this.submitBlock(payload);
  }

  private processRecaptchaFailure(){
    this.clientContext['cookieService'].set('ignite-useRecaptchaV3', false, undefined, undefined, null, true, 'None');
    this.clientContext['cookieService'].set('ignite-reCaptchaVersion', 'V2', undefined, undefined, null, true, 'None');

    setTimeout(() => this.igniteTvSelectionFormSessionComponentRef.instance.triggerRecaptcha(), 10);
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default IgniteTvSelectionFormSession;